import { ApiModule, type PaginatedResponseData } from '@common/index';
import type { PersonHasCourseItem, PersonHasCourse } from '../models';

export class PersonHasCourseApi extends ApiModule {
  protected endpoint = '/person-has-course';

  public async pagePersonHasCourses(params: any) {
    return this.api.post<PaginatedResponseData<PersonHasCourseItem>, any>(
      `${this.endpoint}/page?page=${params.page}&size=${params.itemsPerPage}&sort=${params.sort ?? ''}&sort=${params.sort ?? ''}`,
      {
        ...params
      }
    );
  }

  public loadPersonHasCourseDetails(id: number) {
    return this.api.get<PersonHasCourse>(`${this.endpoint}?id=${id}`);
  }

  public savePersonHasCourse(params: any) {
    return this.api.post(`${this.endpoint}`, {
      ...params
    });
  }

  public deletePersonHasCourse(id: number) {
    return this.api.delete(`${this.endpoint}?id=${id}`);
  }
}
